import { AutogenLayoutTransmissionSchedule } from "./autogen/AutogenLayoutTransmissionSchedule";
import { DataSourceExecutionEvent, DataSourceMode, ClickEvent, Checkbox } from "@mcleod/components";
import { ModelRow } from "@mcleod/core";

export class TransmissionSchedule extends AutogenLayoutTransmissionSchedule {

    private _altPartnerID = "";
    private _version = "";
    private _parentRowID = "";
    private _parentRowType = "";
    private _transactionSet = "";
    private _partnerId = "";
    private _transactionType = "";

    get altPartnerID(): string {
        return this._altPartnerID;
    }

    set altPartnerID(value: string) {
        this._altPartnerID = value;
    }

    get version(): string {
        return this._version;
    }

    set version(value: string) {
        this._version = value;
    }

    get parentRowID(): string {
        return this._parentRowID;
    }

    set parentRowID(value: string) {
        this._parentRowID = value;
    }

    get parentRowType(): string {
        return this._parentRowType;
    }

    set parentRowType(value: string) {
        this._parentRowType = value;
    }

    get transactionSet(): string {
        return this._transactionSet;
    }

    set transactionSet(value: string) {
        this._transactionSet = value;
    }

    get partnerId(): string {
        return this._partnerId;
    }

    set partnerId(value: string) {
        this._partnerId = value;
    }

    get transactionType(): string {
        return this._transactionType;
    }

    set transactionType(value: string) {
        this._transactionType = value;
    }

    /** This is an event handler for the afterExecution event of sourceEdischedule. */
    sourceEdischeduleAfterExecution(event: DataSourceExecutionEvent) {
        if (this.mainDataSource.activeRow == null) {
            this.mainDataSource.setRowsAndMode(DataSourceMode.NONE, [new ModelRow("lme/datafusion/edischedule", false, null)]);
            this.mainDataSource.activeRow?.set("parent_row_id", this.parentRowID);
            this.mainDataSource.activeRow?.set("alt_partner_id", this.altPartnerID);
            this.mainDataSource.activeRow?.set("version", this.version);
            this.mainDataSource.activeRow?.set("partner_id", this.partnerId);
            this.mainDataSource.activeRow?.set("transaction_type", this.transactionType);
            this.mainDataSource.activeRow?.set("transaction_set", this.transactionSet);
            this.mainDataSource.activeRow?.set("parent_row_type", this.parentRowType);
        } else {
            this.updateDayCheckboxes();
        }

    }

    private updateDayCheckboxes(): void {
        // Check if all sun_ fields are checked and update checkboxSunday accordingly
        let allSunFieldsChecked = true;
        for (let i = 0; i <= 23; i++) {
            if (this.mainDataSource.activeRow?.get(`sun_${i}`) !== "Y") {
                allSunFieldsChecked = false;
                break;
            }
        }
        this.checkboxSunday.checked = allSunFieldsChecked;

        // Check if all mon_ fields are checked and update checkboxMonday accordingly
        let allMonFieldsChecked = true;
        for (let i = 0; i <= 23; i++) {
            if (this.mainDataSource.activeRow?.get(`mon_${i}`) !== "Y") {
                allMonFieldsChecked = false;
                break;
            }
        }
        this.checkboxMonday.checked = allMonFieldsChecked;

        // Check if all tue_ fields are checked and update checkboxTuesday accordingly
        let allTueFieldsChecked = true;
        for (let i = 0; i <= 23; i++) {
            if (this.mainDataSource.activeRow?.get(`tue_${i}`) !== "Y") {
                allTueFieldsChecked = false;
                break;
            }
        }
        this.checkboxTuesday.checked = allTueFieldsChecked;

        // Check if all wed_ fields are checked and update checkboxWednesday accordingly
        let allWedFieldsChecked = true;
        for (let i = 0; i <= 23; i++) {
            if (this.mainDataSource.activeRow?.get(`wed_${i}`) !== "Y") {
                allWedFieldsChecked = false;
                break;
            }
        }
        this.checkboxWednesday.checked = allWedFieldsChecked;

        // Check if all thu_ fields are checked and update checkboxThursday accordingly
        let allThuFieldsChecked = true;
        for (let i = 0; i <= 23; i++) {
            if (this.mainDataSource.activeRow?.get(`thu_${i}`) !== "Y") {
                allThuFieldsChecked = false;
                break;
            }
        }
        this.checkboxThursday.checked = allThuFieldsChecked;

        // Check if all fri_ fields are checked and update checkboxFriday accordingly
        let allFriFieldsChecked = true;
        for (let i = 0; i <= 23; i++) {
            if (this.mainDataSource.activeRow?.get(`fri_${i}`) !== "Y") {
                allFriFieldsChecked = false;
                break;
            }
        }
        this.checkboxFriday.checked = allFriFieldsChecked;

        // Check if all sat_ fields are checked and update checkboxSaturday accordingly
        let allSatFieldsChecked = true;
        for (let i = 0; i <= 23; i++) {
            if (this.mainDataSource.activeRow?.get(`sat_${i}`) !== "Y") {
                allSatFieldsChecked = false;
                break;
            }
        }
        this.checkboxSaturday.checked = allSatFieldsChecked;

        // Check if all day checkboxes are checked and update checkboxDayOfWeek accordingly
        const allDayCheckboxesChecked = allSunFieldsChecked && allMonFieldsChecked &&
                                       allTueFieldsChecked && allWedFieldsChecked &&
                                       allThuFieldsChecked && allFriFieldsChecked &&
                                       allSatFieldsChecked;
        this.checkboxDayOfWeek.checked = allDayCheckboxesChecked;
    }

    /** This is an event handler for the onClick event of checkboxSunday. */
    checkboxSundayOnClick(event: ClickEvent) {
        const checkBox = event.target as Checkbox;
        const checked = checkBox.checked;
        for (let i = 0; i <= 23; i++) {
            this.mainDataSource.activeRow?.set(`sun_${i}`, checked ? "Y" : "N");
        }
    }

    /** This is an event handler for the onClick event of checkboxMonday. */
    checkboxMondayOnClick(event: ClickEvent) {
        const checkBox = event.target as Checkbox;
        const checked = checkBox.checked;
        for (let i = 0; i <= 23; i++) {
            this.mainDataSource.activeRow?.set(`mon_${i}`, checked ? "Y" : "N");
        }
    }

    /** This is an event handler for the onClick event of checkboxTuesday. */
    checkboxTuesdayOnClick(event: ClickEvent) {
        const checkBox = event.target as Checkbox;
        const checked = checkBox.checked;
        for (let i = 0; i <= 23; i++) {
            this.mainDataSource.activeRow?.set(`tue_${i}`, checked ? "Y" : "N");
        }
    }

    /** This is an event handler for the onClick event of checkboxWednesday. */
    checkboxWednesdayOnClick(event: ClickEvent) {
        const checkBox = event.target as Checkbox;
        const checked = checkBox.checked;
        for (let i = 0; i <= 23; i++) {
            this.mainDataSource.activeRow?.set(`wed_${i}`, checked ? "Y" : "N");
        }
    }

    /** This is an event handler for the onClick event of checkboxThursday. */
    checkboxThursdayOnClick(event: ClickEvent) {
        const checkBox = event.target as Checkbox;
        const checked = checkBox.checked;
        for (let i = 0; i <= 23; i++) {
            this.mainDataSource.activeRow?.set(`thu_${i}`, checked ? "Y" : "N");
        }
    }

    /** This is an event handler for the onClick event of checkboxFriday. */
    checkboxFridayOnClick(event: ClickEvent) {
        const checkBox = event.target as Checkbox;
        const checked = checkBox.checked;
        for (let i = 0; i <= 23; i++) {
            this.mainDataSource.activeRow?.set(`fri_${i}`, checked ? "Y" : "N");
        }
    }

    /** This is an event handler for the onClick event of checkboxSaturday. */
    checkboxSaturdayOnClick(event: ClickEvent) {
        const checkBox = event.target as Checkbox;
        const checked = checkBox.checked;
        for (let i = 0; i <= 23; i++) {
            this.mainDataSource.activeRow?.set(`sat_${i}`, checked ? "Y" : "N");
        }
    }

    /** This is an event handler for the onClick event of buttonWorkHours. */
    buttonWorkHoursOnClick(event: ClickEvent) {
        // First, uncheck all existing boxes for all days
        this.clearAllChecks();

        // Then set work hours (8 AM - 5 PM, hours 8-17) for Monday through Friday
        const workDays = ['mon', 'tue', 'wed', 'thu', 'fri'];
        for (const day of workDays) {
            for (let hour = 8; hour <= 17; hour++) {
                this.mainDataSource.activeRow?.set(`${day}_${hour}`, "Y");
            }
        }
    }

    private clearAllChecks() {
        const allDays = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];
        for (const day of allDays) {
            for (let hour = 0; hour <= 23; hour++) {
                this.mainDataSource.activeRow?.set(`${day}_${hour}`, "N");
            }
        }

        // Uncheck all day checkboxes
        this.checkboxSunday.checked = false;
        this.checkboxMonday.checked = false;
        this.checkboxTuesday.checked = false;
        this.checkboxWednesday.checked = false;
        this.checkboxThursday.checked = false;
        this.checkboxFriday.checked = false;
        this.checkboxSaturday.checked = false;
        this.checkboxDayOfWeek.checked = false;
    }

/** This is an event handler for the onClick event of checkboxDayOfWeek. */
  checkboxDayOfWeekOnClick(event: ClickEvent) {
    const checkBox = event.target as Checkbox;
    const checked = checkBox.checked;
    this.checkboxSunday.checked = checked;
    this.checkboxMonday.checked = checked;
    this.checkboxTuesday.checked = checked;
    this.checkboxWednesday.checked = checked;
    this.checkboxThursday.checked = checked;
    this.checkboxFriday.checked = checked;
    this.checkboxSaturday.checked = checked;
    const days = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];
    for (const day of days) {
        for (let i = 0; i <= 23; i++) {
            this.mainDataSource.activeRow?.set(`${day}_${i}`, checked ? "Y" : "N");
        }
    }
  }

/** This is an event handler for the onClick event of button3xDay. */
  button3xDayOnClick(event: ClickEvent) {
     // First, uncheck all existing boxes for all days
        this.clearAllChecks();
    // Set 3 times per day (hours 5, 11, and 17) for Monday through Friday
    const workDays = ['mon', 'tue', 'wed', 'thu', 'fri'];
    const dayHours = [5, 11, 17];
    for (const day of workDays) {
      for (const hour of dayHours) {
        this.mainDataSource.activeRow?.set(`${day}_${hour}`, "Y");
      }
    }
  }

/** This is an event handler for the onClick event of buttonOddHours. */
  buttonOddHoursOnClick(event: ClickEvent) {
 // First, uncheck all existing boxes for all days
        this.clearAllChecks();

    // Set all odd hours (1, 3, 5, 7, 9, 11, 13, 15, 17, 19, 21, 23) for Monday through Friday
    const workDays = ['mon', 'tue', 'wed', 'thu', 'fri'];
    for (const day of workDays) {
      for (let hour = 1; hour <= 23; hour += 2) {
        this.mainDataSource.activeRow?.set(`${day}_${hour}`, "Y");
      }
    }
  }

/** This is an event handler for the onClick event of buttonEvenHours. */
  buttonEvenHoursOnClick(event: ClickEvent) {
// First, uncheck all existing boxes for all days
        this.clearAllChecks();

    // Set all even hours (0, 2, 4, 6, 8, 10, 12, 14, 16, 18, 20, 22) for Monday through Friday
    const workDays = ['mon', 'tue', 'wed', 'thu', 'fri'];
    for (const day of workDays) {
      for (let hour = 0; hour <= 22; hour += 2) {
        this.mainDataSource.activeRow?.set(`${day}_${hour}`, "Y");
      }
    }
  }

  /**
   * Validates that required fields are populated when transmission schedule checkboxes are checked
   * Also sets the required property on textboxStart and textboxFrequency based on checkbox state
   * @returns Object containing validation result and whether any checkboxes are checked
   */
  public validateScheduleFields(): { isValid: boolean; hasCheckedBoxes: boolean } {
      // Check if any checkboxes in the transmission panel are checked
      const days = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];
      let anyCheckboxChecked = false;

      for (const day of days) {
          for (let hour = 0; hour < 24; hour++) {
              const fieldName = `${day}_${hour}`;
              if (this.mainDataSource.activeRow?.get(fieldName)) {
                  anyCheckboxChecked = true;
                  break;
              }
          }
          if (anyCheckboxChecked) break;
      }

      // Make textboxStart and textboxFrequency required if any checkbox is checked
      this.textboxStart.required = anyCheckboxChecked;
      this.textboxFrequency.required = anyCheckboxChecked;

      // If no checkboxes are checked, validation passes
      if (!anyCheckboxChecked) {
          return { isValid: true, hasCheckedBoxes: false };
      }

      // Check if required fields are populated when checkboxes are checked
      const startValue = this.mainDataSource.activeRow?.get("start_min_in_hour");
      const frequencyValue = this.mainDataSource.activeRow?.get("frequency_per_hour");

      const isValid = !!(startValue && frequencyValue);

      return { isValid, hasCheckedBoxes: true };
  }


/** This is an event handler for the onClick event of buttonAM. */
  buttonAMOnClick(event: ClickEvent) {
    // First, uncheck all existing boxes for all days
    this.clearAllChecks();

    // Set all AM hours (0-11) for all days of the week
    const allDays = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];
    for (const day of allDays) {
      for (let hour = 0; hour <= 11; hour++) {
        this.mainDataSource.activeRow?.set(`${day}_${hour}`, "Y");
      }
    }
  }

/** This is an event handler for the onClick event of buttonPM. */
  buttonPMOnClick(event: ClickEvent) {
// First, uncheck all existing boxes for all days
    this.clearAllChecks();

    // Set all AM hours (0-11) for all days of the week
    const allDays = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];
    for (const day of allDays) {
      for (let hour = 12; hour <= 23; hour++) {
        this.mainDataSource.activeRow?.set(`${day}_${hour}`, "Y");
      }
    }
  }

/** This is an event handler for the onClick event of buttonAmPm. */
  buttonAmPmOnClick(event: ClickEvent) {
    // First, uncheck all existing boxes for all days
    this.clearAllChecks();

    // Set 11 AM and 5 PM (hours 11 and 17) for all days of the week
    const allDays = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];
    const targetHours = [11, 17];
    for (const day of allDays) {
      for (const hour of targetHours) {
        this.mainDataSource.activeRow?.set(`${day}_${hour}`, "Y");
      }
    }
  }
}
